const Q = require('q');
const pubsub = require('events/pubsub');

const model = require('model/model');
const assignmentService = require('services/assignmentService');
const productService = require('services/productService');

const logger = require('utilities/logger');
const utilities = require('utilities');

const alertUtilities = require('utilities/alertUtilities');
const { isInvalidatingGoogleError } = require('utilities/googleClassroomUtilities');

const STATUS = require('types/AssignmentStatus');
const { DELETED } = STATUS;
const ACTIONS = require('types/AssignmentActions');
const { CHANGE, CHANGE_DEADLINE, SHOW_RESULTS, DELETE, ASSIGNMENT_ACTION_BEGIN, ASSIGNMENT_ACTION_END, CLOSE } = ACTIONS;

const fetchAssignments = () => {
	let classCode = model.get('classCode');

	if (!classCode) {
		return Q().then(() => {
			throw new Error('No class code specified');
		});
	}

	model.set('currentClassAssignments', []);

	return assignmentService
		.teacherGetAssignments({
			classCode
		})
		.then(assignments => {
			var promises = [Q()];
			assignments.sort((a, b) => {
				// Bug fix for older articles (pre Aug 2016)
				// that don't have start date.
				// This essentially sets the startDate = creationTimestamp
				// for those articles.
				var comparatorA = a.startDate || a.creationTimestamp;
				var comparatorB = b.startDate || b.creationTimestamp;

				var startDate = comparatorB - comparatorA;
				if (startDate === 0) {
					return b.creationTimestamp - a.creationTimestamp;
				}
				return startDate;
			});
			assignments.forEach(function (assignment) {
				if (assignment.productMetaData && !assignment.productMetaData.metaData) {
					let pid = assignment.productId;
					promises.push(
						productService
							.get(pid)
							.then(product => {
								if (product) {
									assignment.productMetaData.metaData = product.metaData;
									assignment.productMetaData.minGrade = product.minGrade;
									assignment.productMetaData.maxGrade = product.maxGrade;
									assignment.productMetaData.questionSets = product.questionSets;
									assignment.productMetaData.hasVideo = product.hasVideo;
									if (product.img) {
										assignment.productMetaData.img = product.img;
										assignment.productMetaData.imgAlt = product.imgAlt;
									} else if (product.productType === 'P') {
										// Paired text should have new thumbnail on the root product,
										// but is likely missing on older product versions
										let deconstructedProductVersion = utilities.parseProductUUIDAndVersion(pid);
										let rootPid = deconstructedProductVersion.uuid;

										if (rootPid) {
											return productService.get(rootPid).then(rootProduct => {
												assignment.productMetaData.img = rootProduct.img;
											});
										}
									}
								}
								return Q();
							})
							.catch(() => {
								logger.error('Product not found. ', pid);
							})
					);
				}
			});

			return Q.all(promises).then(() => {
				model.set('currentClassAssignments', assignments);
				return assignments;
			});
		});
};

const takeAssignmentAction = (action, assignment, roster) => {
	let modal = null;

	if (action === CHANGE) {
		modal = '#modal-assign';
	} else if (action === CHANGE_DEADLINE) {
		modal = '#change-deadline-modal';
	} else if (action === SHOW_RESULTS) {
		modal = '#modal-show-results';
	} else if (action === DELETE) {
		modal = '#modal-confirm-delete';
	} else if (action === CLOSE) {
		modal = '#modal-close-assignment';
	}

	if (modal) {
		utilities.openModal(modal, {
			assignment,
			roster
		});
	}
};

const deleteAssignment = assignment => {
	let localGCAccessToken = model.get('localGCAccessToken');
	const needsToken = assignment.gcid || assignment.gca;
	let params = {
		assignmentStatus: DELETED,
		classCode: assignment.classCode,
		assignmentId: assignment.assignmentId
	};

	if (needsToken && localGCAccessToken) {
		params.token = localGCAccessToken;
	} else if (needsToken) {
		alertUtilities.error('Please log in with Google again.');
		return Q.reject();
	}

	return assignmentService
		.teacherUpdateAssignment(params)
		.then(() => {
			alertUtilities.success('Assignment "' + assignment.productMetaData.title + '" has been deleted.');
		})
		.fail(error => {
			if (isInvalidatingGoogleError(error)) {
				model.remove('localGCAccessToken');
			}
		});
};

const closeAssignment = assignment => {
	return assignmentService.closeAssignment({
		cc: assignment.classCode,
		aid: assignment.assignmentId
	});
};

const beginAssignmentAction = () => {
	pubsub.publish(ASSIGNMENT_ACTION_BEGIN);
};
const endAssignmentAction = () => {
	pubsub.publish(ASSIGNMENT_ACTION_END);
};

module.exports = {
	STATUS,
	ACTIONS,

	beginAssignmentAction,
	endAssignmentAction,

	fetchAssignments,
	takeAssignmentAction,
	deleteAssignment,
	closeAssignment
};
